import { bsNameMap } from "../constants";
import { appstr } from "./appstr.js";

export function GetBSOption(bsOption) {
  var bsName = bsNameMap[bsOption];
  if (bsName == null) return null;

  return appstr(bsName);
}
